import React, { useState } from 'react';
import "./MarketPlaceShoppingCart.css"
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from "react-redux";
import RazorpayCheckout from '../PaymentStrip/razorpayCheckout';
import LoaderComponent from '../LoaderComponent/LoaderComponent';       //css hila hua
import LoadingComponent from '../LoadingComponent/LoadingComponent';    //bakwas
import { Ring } from '@uiball/loaders';
import { arrow_Forward_whiteee } from '../../assets/images/images';
import { Tooltip } from "@mui/material";

function MarketplacePriceChekoutList({ close,disabled }) {
    const navigate = useNavigate();
    const priceData = useSelector((state) => state.cartlist);
    //const isIndia = useSelector((state) => state.globalState?.isIndia);  //getting user location from global state
    const location = useSelector((state) => state?.globalState?.student_details?.data?.location)
    const getLocation = location.split(",").pop().trim();
    const Location = getLocation ? getLocation : "India"; 
    const isIndia = Location === "India";
    const currency_symbol = useSelector((state)=>state?.globalState?.currency_symbol)
    const [loading , setloading] = useState(false)



    const [showRazorpay, setShowRazorpay] = useState(false);

    const isOnlyOneFreeCourse =
    priceData?.cartList?.length === 1 &&
    priceData?.cartList?.[0]?.price === null;

    const handleCheckout = () => {

        if (isIndia) {
            setShowRazorpay(true);    //if you want razorpay 
            // navigate("/Checkout");    //if you want stripe

        } else {
            navigate("/Checkout");
            // console.log("h");

        }
    };


    // Calculate total price
    // const calculateTotalPrice = () => {

    //     //the numbers is coming string that why 30.00 +20.00  is giving 30.0020.00 instead of 50.00 so we need to convert it into number using parseFloat
    //     // let totalPrice = 0;
    //     // priceData.cartList.forEach(item => {
    //     //     totalPrice += item.discounted_price === null ? item?.price : item?.discounted_price;
    //     // });
    //     // return totalPrice.toFixed(2); // Format to 2 decimal places
    //     let totalPrice = 0;
    //     priceData.cartList.forEach(item => {
    //         const price = parseFloat(item.discounted_price ?? item.price) || 0;
    //         totalPrice += price;
    //     });
    //     return totalPrice.toFixed(2);
    // } 999999.99


    //ameya issue solved 
    const calculateTotalPrice = () => {
    if (!priceData?.cartList || !Array.isArray(priceData.cartList)) return "0.00";

    let totalPrice = 0;
    priceData.cartList.forEach(item => {
        // ✅ if discounted_price is not null, use it — else use price
        const price = item?.discounted_price != null 
            ? parseFloat(item.discounted_price) 
            : parseFloat(item?.price);
        
        totalPrice += isNaN(price) ? 0 : price; 
    });

        // console.log("totalPrice:", totalPrice, typeof totalPrice); // ✅ add this


    return totalPrice.toFixed(2);
}

const totalPrice = parseFloat(calculateTotalPrice());

const priceLimit = currency_symbol === "₹" ? 100000 : 999999.99;
const isOverLimit = totalPrice > priceLimit;

const formattedLimit = currency_symbol === "₹" 
  ? "₹1,00,000" 
  : "$999,999.99";

    return (
      <>
        <div className="marketplace-shopping-cart-right-section">
          <div className="marketplace-price-container">
            <div className="marketplace-price-header">
              <div className="marketplace-price">
                {/* <p>Price ({priceData?.cartList?.length} courses)</p> */}
                {/* <p>Courses ({priceData?.cartList?.length})</p> */}
                <p>Billing Summary</p>
                {/* <h2 className='price'>${calculateTotalPrice()}</h2> */}
              </div>
              <div className="marketplace-course-price-scroller-folder">
                {priceData?.cartList?.length === 0 ? (
                  <p>No Courses Found</p>
                ) : isOnlyOneFreeCourse ? (
                  <p
                    style={{
                      color: "#808080",
                      fontSize: "14px",
                      margin: "10px 0",
                      textAlign: "center",
                      fontStyle: "italic",
                    }}
                  >
                    No items available for payment in your cart.
                  </p>
                ) : (
                  priceData?.cartList
                    ?.filter((items) => items?.price !== null)
                    .map((items, index) => (
                      <div className="marketplace-course-price-scroller">
                        <button
                          type="button"
                          onClick={() =>
                            navigate(`/course/${items.course_id}/view`, {
                              state: {
                                redirectTo: "cart",
                                course: { ...items, in_cart: true },
                              },
                            })
                          }
                          data-tooltip-id="course-name"
                          data-tooltip-content={items?.name}
                        >
                          {items?.name?.length > 19
                            ? `${items.name.substring(0, 15)}...`
                            : items?.name}
                        </button>
                        <p>
                          {/* <span onClick={() => close(items.cart_item_id)}><i class="fa-solid fa-x"></i></span> */}
                          {currency_symbol ?? ""}
                          {items?.discounted_price === null
                            ? items?.price
                            : items?.discounted_price}
                        </p>
                      </div>
                    ))
                )}
              </div>
              {/* <div className='marketplace-inner-price'>
                            <span>Summer Special</span>
                            <span>-$4.99 <i class="fa-solid fa-x"></i></span>
                        </div> */}
            </div>
            {!isOnlyOneFreeCourse && (
              <div>
                <div className="marketplace-price">
                  <p>Total</p>
                  <h2>
                    {currency_symbol ?? ""}
                    {calculateTotalPrice()}
                  </h2>
                </div>
                {isOverLimit && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      fontStyle: "italic",
                      marginTop: "4px",
                    }}
                  >
                    Total price should not exceed {formattedLimit}
                  </p>
                )}
              </div>
            )}
            {/* <div className='cupen-Applied-btn'>
                        <textarea rows="1" placeholder='Enter Promo Code'/>
                        <button>Apply</button>
                    </div> */}

            {/* BHUMESH: */}

            {/* <button className='price-checkout-btn' onClick={() => navigate(`/Checkout`)} 


                     style={{
                        backgroundColor: priceData?.cartList.length !== 0 ? '#0068FF' : 'gray', // Change 'normalBackgroundColor' to your desired color
                        color: priceData?.cartList.length !== 0 ? '#ffffff' : 'colorWhenDisabled', // Optionally set the text color
                    }}
                    disabled={priceData?.cartList.length === 0}>Checkout</button>  */}

            <button
              className="price-checkout-btn"
              onClick={handleCheckout}
              style={{
                backgroundColor:
                  priceData?.cartList.length !== 0 &&
                  !isOnlyOneFreeCourse &&
                  !isOverLimit &&
                  !disabled
                    ? "#0068FF"
                    : "gray",
                color:
                  priceData?.cartList.length !== 0 &&
                  !isOnlyOneFreeCourse &&
                  !isOverLimit &&
                  !disabled
                    ? "#ffffff"
                    : "colorWhenDisabled",
              }}
              disabled={
                priceData?.cartList.length === 0 ||
                loading ||
                isOnlyOneFreeCourse ||
                isOverLimit ||
                disabled
              }
            >
              {loading ? (
<Ring size={23} color ={"#40f399"} />              ) : (
                <>
                  {" "}
                  Proceed to Checkout{" "} 
                  <img
                    src={arrow_Forward_whiteee}
                    alt="checkout"
                    style={{ width: "13px", height: "18px", marginLeft: "8px" }}
                  />{" "}
                </>
              )}
            </button>

            {showRazorpay && (
              <RazorpayCheckout
                onClose={() => setShowRazorpay(false)}
                setloading={setloading}
              />
            )}

            {/* for testing purpose i am attaching both stripe and razore pay checkout */}
            {/* <button className='price-checkout-btn' onClick={() => navigate(`/Checkout`)}


                        style={{
                            backgroundColor: priceData?.cartList.length !== 0 ? '#0068FF' : 'gray', // Change 'normalBackgroundColor' to your desired color
                            color: priceData?.cartList.length !== 0 ? '#ffffff' : 'colorWhenDisabled', // Optionally set the text color
                        }}
                        disabled={priceData?.cartList.length === 0}>Checkout stripe </button> */}
          </div>
        </div>
      </>
    );
}

export default MarketplacePriceChekoutList;


//12-03-26 : i have integrated on the basis of global state profile loctaion.